import { YardiBreezeConnectForm } from './YardiBreezeConnectForm'
import type { VendorConnectorProps } from './types'

export function YardiBreezeConnector({ onConnected }: VendorConnectorProps) {
  return <YardiBreezeConnectForm onConnected={() => onConnected?.()} />
}
